<template>
  <div class="layout-app" :class="current_mode" :dir="$page.props.dir">
      <div id="dropdown" />
    <div class="md:flex md:flex-col">
      <div class="md:h-screen md:flex md:flex-col">
        <div class="md:flex md:shrink-0 !h-14">
          <div class="flex items-center justify-between md:shrink-0 md:w-64 md:justify-center sidebar-left-top">
              <Link href="/">
                  <logo class="help-desk-logo" />
              </Link>
              <dropdown class="md:hidden" className="small-menu" placement="bottom-end">
                  <template #default>
                      <svg class="w-6 h-6 mobile-menu-selector" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
                  </template>
                  <template #dropdown>
                      <div class="px-8 py-4 mt-2 rounded shadow-lg bg-hd-sidebar">
                          <main-menu :auth="auth" />
                      </div>
                  </template>
              </dropdown>
          </div>
          <div class="flex items-center w-full px-4 text-sm bg-white top_bar">
              <div class="placement-top-left">
                  <!-- Account Switcher (Notifuse-style) -->
                  <div class="topbar-account-switcher" ref="topbarAccountDropdown" v-if="$page.props.auth.user && $page.props.auth.user.accounts">
                      <button class="topbar-account-btn" @click="toggleAccountDropdown">
                          <div class="topbar-account-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
                          </div>
                          <span class="topbar-account-name">{{ currentAccount?.name || $page.props.auth.user.name }}</span>
                          <svg class="topbar-chevron" :class="{ 'rotated': accountDropdownOpen }" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
                      </button>
                      <transition name="topbar-dropdown">
                          <div v-if="accountDropdownOpen" class="topbar-account-dropdown">
                              <div class="topbar-dropdown-header">Changer de compte</div>
                              <div
                                  v-for="(account, index) in $page.props.auth.user.accounts"
                                  :key="index"
                                  class="topbar-dropdown-item"
                                  :class="{ 'active': account.id === currentAccount?.id }"
                                  @click="switchAccount(account)"
                              >
                                  <div class="topbar-item-avatar">
                                      <span>{{ account.name?.charAt(0)?.toUpperCase() }}</span>
                                  </div>
                                  <div class="topbar-item-info">
                                      <div class="topbar-item-name">{{ account.name }}</div>
                                      <div class="topbar-item-type">{{ account.type || 'Compte' }}</div>
                                  </div>
                                  <svg v-if="account.id === currentAccount?.id" class="topbar-check-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                              </div>
                          </div>
                      </transition>
                  </div>
              </div>
              <div class="placement-top-right">
                  <!-- Help button -->
                  <dropdown class="topbar-help-wrapper" placement="bottom-end">
                      <template #default>
                          <div class="topbar-help-btn">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                              <span>Aide</span>
                          </div>
                      </template>
                      <template #dropdown>
                          <div class="topbar-help-dropdown">
                              <a href="https://docs.example.com" target="_blank" class="topbar-help-item">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
                                  <span>Documentation</span>
                              </a>
                              <a href="https://github.com/issues" target="_blank" class="topbar-help-item">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                                  <span>Signaler un problème</span>
                              </a>
                          </div>
                      </template>
                  </dropdown>
                  <dropdown class="select_user" placement="bottom-end">
                      <template #default>
                          <div class="topbar-user-btn" style="margin-left: 8px;">
                              <div class="topbar-user-avatar">
                                  <img v-if="$page.props.auth.user.photo" class="topbar-user-photo" :alt="$page.props.auth.user.first_name" :src="$page.props.auth.user.photo" />
                                  <span v-else>{{ ($page.props.auth.user.first_name || '?').charAt(0).toUpperCase() }}</span>
                              </div>
                              <span class="topbar-user-name">{{ $page.props.auth.user.first_name }} {{ $page.props.auth.user.last_name }}</span>
                              <svg class="topbar-chevron" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
                          </div>
                      </template>
                      <template #dropdown>
                          <div class="text-sm bg-white rounded shadow-xl">
                              <Link class="block px-6 py-2 hover:bg-[#2c7d4e] hover:text-white" :href="route('users.edit.profile')">{{ __('Edit Profile') }}</Link>
                              <Link class="block w-full px-6 py-2 text-left hover:bg-[#2c7d4e] hover:text-white" :href="route('logout')" method="delete" as="button">{{ __('Logout') }}</Link>
                          </div>
                      </template>
                  </dropdown>
              </div>
          </div>
        </div>
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <main-menu class="hidden overflow-y-auto md:block sidebar shrink-0 md:w-64" />
          <div class="md:flex-1 md:overflow-y-auto" scroll-region>
              <div class="container-head">
                  <div class="ch-left">
                      <div class="text-sm breadcrumb">
                          <Link :href="route('dashboard')"><icon class="w-3 h-3" name="home" /></Link>
                          <span class="b-item">/</span>
                          <Link v-if="edit_route" :href="route(edit_route)" class="capitalize">{{ edit_route == 'tickets' ? 'Tickets' : (edit_route == 'users' ? 'Utilisateurs' : (edit_route == 'roles' ? 'Rôles' : (edit_route == 'account.config' ? 'Config Compte' : edit_route))) }}</Link>
                          <span v-if="edit_route" class="b-item">/</span>
                          <span class="b-item">{{ __(title) }}</span>
                      </div>
                  </div>
                  <div class="cursor-pointer ch-right">
                      <button class="theme-toggle" id="theme-toggle" title="Toggles light & dark" :aria-label="current_mode" aria-live="polite" @click="switchMode">
                          <svg class="sun-and-moon" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24">
                              <mask class="moon" id="moon-mask">
                                  <rect x="0" y="0" width="100%" height="100%" fill="white" />
                                  <circle cx="24" cy="10" r="6" fill="black" />
                              </mask>
                              <circle class="sun" cx="12" cy="12" r="6" mask="url(#moon-mask)" fill="currentColor" />
                              <g class="sun-beams" stroke="currentColor">
                                  <line x1="12" y1="1" x2="12" y2="3" />
                                  <line x1="12" y1="21" x2="12" y2="23" />
                                  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                                  <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                                  <line x1="1" y1="12" x2="3" y2="12" />
                                  <line x1="21" y1="12" x2="23" y2="12" />
                                  <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                                  <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
                              </g>
                          </svg>
                      </button>
                  </div>
              </div>
            <flash-messages />
              <div class="sec-cont">
                  <slot />
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
import { Link, router } from '@inertiajs/vue3'
import moment from 'moment'
import 'moment/locale/fr';
import axios from 'axios'

export default {
    components: {
        Dropdown,
        FlashMessages,
        Icon,
        Logo,
        Link,
        MainMenu,
    },
    props: {
        title: String,
    },
    data() {
        return {
            time: '',
            current_mode: 'light',
            modes: ['dark', 'light'],
            edit_route: '',
            balance: '',
            currentAccount: null,
            accountDropdownOpen: false,
        }
    },
    computed: {
        currentAccountInitial() {
            return this.currentAccount?.name?.charAt(0)?.toUpperCase()
                || this.$page.props.auth.user?.name?.charAt(0)?.toUpperCase()
                || '?'
        },
        selected_language() {
            return this.$page.props.languages.find(language => language.code === this.$page.props.locale)
        },
        languages_except_selected(){
            return this.$page.props.languages.filter(language => language.code !== this.$page.props.locale)
        }
    },
    methods:{
        toggleAccountDropdown() {
            this.accountDropdownOpen = !this.accountDropdownOpen
        },
        switchAccount(account) {
            if (account.id === this.currentAccount?.id) {
                this.accountDropdownOpen = false
                return
            }
            router.post(route('accounts.switch'), { account_id: account.id }, {
                preserveScroll: false,
                onSuccess: () => {
                    this.currentAccount = account
                    this.accountDropdownOpen = false
                },
                onError: (errors) => console.error('Erreur changement de compte:', errors)
            })
        },
        handleAccountClickOutside(e) {
            if (this.$refs.topbarAccountDropdown && !this.$refs.topbarAccountDropdown.contains(e.target)) {
                this.accountDropdownOpen = false
            }
        },
        generateGreetings(){
            const currentHour = this.moment().format('HH')
            if (currentHour >= 3 && currentHour < 12){
                return 'Bonjour'
            } else if (currentHour >= 12 && currentHour < 15){
                return 'Bon Midi'
            }else if (currentHour >= 15 && currentHour < 18){
                return 'Bonsoir'
            }   else if (currentHour >= 18 && currentHour < 20){
                return 'Bonsoir'
            } else {
                return 'Hello'
            }
        },
        switchMode(){
            this.current_mode = this.current_mode === 'light' ? 'dark' : 'light'
            localStorage.setItem('current_mode', this.current_mode)
        },
        detectCurrentUrl(){
            const url = this.$page.url;
            const splitUrl = url.split('/');
            let editString = ['edit', 'create'].includes(url.substring(url.lastIndexOf("/") + 1));
            if(!editString){
                editString = splitUrl[splitUrl.length - 2] === 'tickets';
            }
            let editRoute = url.split('/')[2]
            if(['settings','front_pages'].includes(editRoute)){
                editRoute = url.split('/')[3];
            }
            if(editRoute === 'account'){
                editRoute = 'account.config';
            }
            this.edit_route = editString? ((editRoute == 'create' || editRoute == 'edit') ? url.split('/')[2] : editRoute ) : '';
        },
        getCurrentBalance() {
            axios.get(this.route('current.balance')).then((res)=>{
                this.balance = res.data ;
            })
        }
    },
    mounted() {
        document.addEventListener('click', this.handleAccountClickOutside)
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleAccountClickOutside)
    },
    updated() {
        this.detectCurrentUrl()
    },
    created() {
        this.moment = moment;
        this.moment.locale('fr');
        this.currentAccount = this.$page.props.auth.current_account
            || this.$page.props.auth.user?.accounts?.[0]
            || null
        let vm = this
        if(localStorage.getItem('current_mode')){
            this.current_mode = localStorage.getItem('current_mode')
        }
        vm.time = vm.moment().local().format('YYYY MMMM Do, HH:mm')
        window.setInterval(function () {
            vm.time = vm.moment().local().format('YYYY MMMM Do, HH:mm ')
        }, 1000)
        this.detectCurrentUrl()
        this.getCurrentBalance()
    }
}
</script>

<style scoped>
/* ── Account switcher ── */
.topbar-account-switcher { position: relative; }

.topbar-account-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    background: transparent;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 4px 8px 4px 6px;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;
    color: #374151;
}
.topbar-account-btn:hover { background: rgba(0,0,0,0.04); border-color: #d1d5db; }

.topbar-account-icon {
    display: flex;
    align-items: center;
    color: #6b7280;
}

.topbar-account-name {
    font-size: 0.8125rem;
    font-weight: 500;
    color: #111827;
    white-space: nowrap;
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.topbar-chevron {
    color: #9ca3af;
    flex-shrink: 0;
    transition: transform 0.2s;
}
.topbar-chevron.rotated { transform: rotate(180deg); }

.topbar-account-dropdown {
    position: absolute;
    left: 0;
    top: calc(100% + 4px);
    min-width: 220px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    box-shadow: 0 6px 20px rgba(0,0,0,0.08);
    z-index: 200;
    overflow: hidden;
}

.topbar-dropdown-header {
    padding: 7px 12px;
    font-size: 0.65rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    color: #9ca3af;
    border-bottom: 1px solid #f3f4f6;
}

.topbar-dropdown-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 12px;
    cursor: pointer;
    transition: background 0.15s;
}
.topbar-dropdown-item:hover { background: rgba(0,0,0,0.04); }
.topbar-dropdown-item.active { background: rgba(44,125,78,0.07); }

.topbar-item-avatar {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: linear-gradient(135deg, #06b6d4, #3b82f6);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.68rem;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
}
.topbar-dropdown-item.active .topbar-item-avatar { background: linear-gradient(135deg, #2c7d4e, #4ade80); }

.topbar-item-info { flex: 1; overflow: hidden; }
.topbar-item-name {
    font-size: 0.8rem;
    font-weight: 500;
    color: #111827;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.topbar-item-type { font-size: 0.68rem; color: #9ca3af; }
.topbar-check-icon { color: #2c7d4e; flex-shrink: 0; }

/* ── Help button ── */
.topbar-help-btn {
    display: flex;
    align-items: center;
    gap: 5px;
    background: transparent;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 4px 10px;
    cursor: pointer;
    font-size: 0.8125rem;
    font-weight: 500;
    color: #374151;
    transition: background 0.15s, border-color 0.15s;
    white-space: nowrap;
}
.topbar-help-btn:hover { background: rgba(0,0,0,0.04); border-color: #d1d5db; }
.topbar-help-btn svg { color: #6b7280; flex-shrink: 0; }

.topbar-help-dropdown {
    min-width: 190px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    box-shadow: 0 6px 20px rgba(0,0,0,0.08);
    overflow: hidden;
    padding: 4px;
}
.topbar-help-item {
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 8px 12px;
    border-radius: 5px;
    font-size: 0.8125rem;
    color: #374151;
    text-decoration: none;
    transition: background 0.12s;
}
.topbar-help-item:hover { background: rgba(0,0,0,0.04); color: #111827; }
.topbar-help-item svg { color: #6b7280; flex-shrink: 0; }

/* ── User button (right side) ── */
.topbar-user-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    background: transparent;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 4px 10px 4px 4px;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;
    white-space: nowrap;
}
.topbar-user-btn:hover { background: rgba(0,0,0,0.04); border-color: #d1d5db; }

.topbar-user-avatar {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: linear-gradient(135deg, #7c3aed, #a78bfa);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.65rem;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
    overflow: hidden;
}
.topbar-user-photo { width: 100%; height: 100%; object-fit: cover; }

.topbar-user-name {
    font-size: 0.8125rem;
    font-weight: 500;
    color: #111827;
    white-space: nowrap;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ── Dropdown animation ── */
.topbar-dropdown-enter-active,
.topbar-dropdown-leave-active { transition: opacity 0.12s, transform 0.12s; }
.topbar-dropdown-enter-from,
.topbar-dropdown-leave-to { opacity: 0; transform: translateY(-4px); }

/* ── Dark mode ── */
:global(.dark) .topbar-account-btn { border-color: rgba(255,255,255,0.1); color: #e2e8f0; }
:global(.dark) .topbar-account-btn:hover { background: rgba(255,255,255,0.06); }
:global(.dark) .topbar-account-name { color: #e2e8f0; }
:global(.dark) .topbar-account-icon { color: rgba(255,255,255,0.4); }
:global(.dark) .topbar-chevron { color: rgba(255,255,255,0.35); }
:global(.dark) .topbar-account-dropdown {
    background: #1e2130;
    border-color: rgba(255,255,255,0.1);
    box-shadow: 0 6px 20px rgba(0,0,0,0.3);
}
:global(.dark) .topbar-dropdown-header { color: rgba(255,255,255,0.3); border-color: rgba(255,255,255,0.07); }
:global(.dark) .topbar-dropdown-item:hover { background: rgba(255,255,255,0.05); }
:global(.dark) .topbar-dropdown-item.active { background: rgba(44,125,78,0.18); }
:global(.dark) .topbar-item-name { color: #e2e8f0; }
:global(.dark) .topbar-item-type { color: rgba(255,255,255,0.3); }
:global(.dark) .topbar-user-btn { border-color: rgba(255,255,255,0.1); }
:global(.dark) .topbar-user-btn:hover { background: rgba(255,255,255,0.06); }
:global(.dark) .topbar-user-name { color: #e2e8f0; }
:global(.dark) .topbar-help-btn { border-color: rgba(255,255,255,0.1); color: #e2e8f0; }
:global(.dark) .topbar-help-btn:hover { background: rgba(255,255,255,0.06); }
:global(.dark) .topbar-help-btn svg { color: rgba(255,255,255,0.4); }
:global(.dark) .topbar-help-dropdown { background: #1e2130; border-color: rgba(255,255,255,0.1); box-shadow: 0 6px 20px rgba(0,0,0,0.3); }
:global(.dark) .topbar-help-item { color: rgba(255,255,255,0.7); }
:global(.dark) .topbar-help-item:hover { background: rgba(255,255,255,0.06); color: #e2e8f0; }
:global(.dark) .topbar-help-item svg { color: rgba(255,255,255,0.35); }
</style>
